import Lottie from "lottie-react";
import DoneGIF from "components/done_gif.json";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const REDIRECT_DELAY_MS = 4000;
const HOME_PATH = "/";

export const VerifySuccessScreen = () => {
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(
      () => history.replace(HOME_PATH),
      REDIRECT_DELAY_MS
    );

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <div className="t-min-h-screen t-flex t-items-center t-justify-center">
      <div className="t-w-[560px] t-border t-border-solid t-border-neutral-10 t-rounded-t-lg t-bg-white t-shadow-light-30 t-p-8 t-flex t-flex-col t-items-center t-text-center">
        <Lottie
          className="t-size-[120px]"
          animationData={DoneGIF}
          loop={true}
        />

        <div className="t-text-subtitle-lg t-text-text-100 t-mt-2.5">
          Workspace setup complete!
        </div>
        <div className="t-text-body-sm t-text-text-30 t-mt-2 t-mx-8">
          Your company and entity details have been verified successfully. You
          are all set to start.
        </div>

        <div className="t-text-body-sm t-text-text-30 t-mt-6">
          Redirecting.....
        </div>
      </div>
    </div>
  );
};
